import {Fab, Tooltip, Zoom} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import React, {useState} from "react";
import Inquiry from "./inquiry";

export default function InquiryButton(props) {
  const [openCenter, setOpenCenter] = useState(false);

  const handleClickServiceCenterDetail = () => {
    setOpenCenter(prev => !prev)
  };

  return (
    <>
    <Tooltip
      arrow
      title='상담문의 010-4968-6086'
      placement='left'
      TransitionComponent={Zoom}>
      <Fab
        onClick={handleClickServiceCenterDetail}
        variant='extended'
        sx={{
          position: 'fixed',
          right: {xs: '12px', md: '2%'},
          bottom: {xs: '14px', md: '6%'},
          zIndex: 1200,
          backgroundColor: '#5A4231',
          color: '#FCFCFC',
          /* 모바일에서 크게 뜨면 본문 글자를 가린다 */
          fontSize: {xs: '0.9em', md: '1.3em'},
          p: {xs: '0.5em 0.9em', md: '1em'},
          whiteSpace: 'nowrap',
          transition: '1s',
          '&:hover': {
            backgroundColor: '#FFFACB',
            color: '#5A4231',
            transform: 'scale(1.02)'
          }
        }}>
        상담문의
        <ChatIcon sx={{marginLeft: '6px', fontSize: '1.3em'}}/>
      </Fab>
    </Tooltip>

      <Inquiry open={openCenter} companyData={props.companyData} handleClick={handleClickServiceCenterDetail}/>
    </>
  )
}